import React, {useEffect, useRef, useState} from 'react'
import { ChatBottom } from './ChatBottom'
import Application from 'app/pages/component/types/cleaner/application'
import { DateFormat } from 'sr/helpers/functions/DateFormat'
import { getMessage } from 'sr/utils/api/cleaner/getMessage'
import { getUserDetails } from 'sr/helpers/functions/getUserDetails'
import getTimeFromDate from 'sr/helpers/functions/getTimeFromDate'
import { LoaderFullScreen } from 'sr/layout/common/LoaderFullScreen'
import { formatISO } from 'date-fns'
import { scrollToBottom } from 'sr/helpers/functions/scrollToBottom'
import { useSocket } from 'app/pages/component/SocketContext'
import { uploadFile } from 'sr/utils/api/uploadFile'
import { ChatImg } from 'app/pages/individual/jobs/component/ChatImg'
import { DisplayMessageReceiver } from 'app/pages/component/DisplayMessageReceiver'
interface PropsType {
  data:Application
  fetchUnreadCount:any
  fetchUnreadApplication:any
  clearUnreadForJob:any
  updateLastMessageTime?: (cleanerId: string, jobId: string, time: string) => void
}
export const ChatBox = (props:PropsType) => {
    const [message, setMessage] = useState<string>('');
    const [allmessage, setAllMessage] = useState<any>([])
    const [cleanerId, setCleanerId] = useState<string>()
    const [loader, setLoader] = useState(false)
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [totalPage, setTotalPage] = useState(0)
    const messagesEndRef = useRef<any>(null);
    const previousScrollHeightRef = useRef<number>(0);
    const previousScrollTopRef = useRef<number>(0);
        const [imageId, setImageId] = useState('')
          const [imageUrl, setImageUrl] = useState('')
    
    useEffect(()=> {
      const {user_id} = getUserDetails()
      setCleanerId(user_id)
    },[])
    const socket = useSocket()
    const getMessageId = (item) => item?._id || item?.id
       useEffect(() => {
        if(!socket || !cleanerId) return

        socket.emit('register', cleanerId);

        const handleSendMessage = ({ from, messagewithFullData: message}) => {
          const msgRecipientId = typeof message?.recipient_id === 'string' ? message?.recipient_id : (message?.recipient_id?._id || message?.recipient_id?.id);
          const msgSenderId = typeof message?.sender_id === 'string' ? message?.sender_id : (message?.sender_id?._id || message?.sender_id?.id);
          const msgJobId = typeof message?.job_id === 'string' ? message?.job_id : (message?.job_id?._id || message?.job_id?.id);

          const expectedCompanyId = typeof props?.data?.job_id?.company_id === 'string' ? props?.data?.job_id?.company_id : (props?.data?.job_id?.company_id?._id || props?.data?.company_id);

          if (msgSenderId !== expectedCompanyId || msgJobId !== props?.data?.job_id?._id || msgRecipientId !== cleanerId) {
            return
          }

          const currentDateTime = formatISO(new Date());
          
          const tempId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
          const newmessage = {createdAt:currentDateTime, _id: tempId, ...message}
          
          setAllMessage((preview)=> {
            return [...preview, newmessage]
          })
          
          const companyId = typeof props?.data?.job_id?.company_id === 'string' ? props?.data?.job_id?.company_id : (props?.data?.job_id?.company_id?._id);
          if (props.updateLastMessageTime) props.updateLastMessageTime(companyId, props.data.job_id._id, currentDateTime);
          setTimeout(() => scrollToBottom(messagesEndRef), 100);
          props?.clearUnreadForJob(message?.job_id)

          setTimeout(() => {
              if (page === 1) {
                  fetchChat(props?.data?.job_id?._id, cleanerId, expectedCompanyId, false);
              }
          }, 1500);
        }

        socket.on('sendmessage', handleSendMessage);

        return () => {
          socket.off('sendmessage', handleSendMessage);
        };
      }, [socket, cleanerId, props?.data?.job_id?._id, props?.data?.company_id]);

      const sendMessage = () => {
        
       if (!message?.trim()?.length && !imageId) {
          return
        }
        const recipientCompanyId = typeof props?.data?.job_id?.company_id === 'string'
            ? props?.data?.job_id?.company_id
            : (props?.data?.job_id?.company_id?._id || props?.data?.job_id?.company_id?.id);

        const payload = {
            message: message,
            recipient_id: recipientCompanyId,
            sender_id:cleanerId,
            job_id:props?.data?.job_id?._id,
            file_id:imageId,
            type:'chat',
            sender_id_type:'cleaner',
        recipient_id_type:'company',
        };
     
    
        socket.emit('sendmessage', payload);
        setMessage('');
        const currentDateTime = formatISO(new Date());
        const newmessage = {createdAt:currentDateTime, ...payload}
        setAllMessage((preview)=> [...preview, newmessage])
        const companyIdForSort = typeof props?.data?.job_id?.company_id === 'string' ? props?.data?.job_id?.company_id : (props?.data?.job_id?.company_id?._id);
        if (props.updateLastMessageTime) props.updateLastMessageTime(companyIdForSort, props.data.job_id._id, currentDateTime);
        setTimeout(() => scrollToBottom(messagesEndRef), 100);
        setImageId('')
        setImageUrl('')
    };

       const fetchChat = async (job_id, sender_id, recipient_id, showLoader = true)=> {
        if(showLoader) setLoader(true)
        const queryParams = new URLSearchParams()
        queryParams?.append('job_id', job_id)
           const filter =  {
      "$and":[{"$or":[{"$and":[{"recipient_id":recipient_id}, {"sender_id":sender_id}]},  {"$and":[{"recipient_id":sender_id}, {"sender_id":recipient_id}]}]}]
    }

        queryParams.append('page', page?.toString())
        queryParams.append('limit', limit?.toString())
        queryParams.append('filter', JSON.stringify(filter))
    try {
    const res = await getMessage(queryParams)
    if(res?.success===true) {
        if (messagesEndRef.current && page > 1) {
            previousScrollHeightRef.current = messagesEndRef.current.scrollHeight;
            previousScrollTopRef.current = messagesEndRef.current.scrollTop;
        }

    setAllMessage((prev) => {
      const cleanPrev = prev?.filter((msg) => msg._id && !msg._id.toString().startsWith('temp_')) || [];
      const fetchedMessages = res?.data || []
      const existingIds = new Set(cleanPrev.map(getMessageId).filter(Boolean));
      const newMessages = fetchedMessages.filter((msg) => {
        const messageId = getMessageId(msg)
        return !messageId || !existingIds.has(messageId)
      });
      return [...cleanPrev, ...newMessages];
    });

  
    if (res?.data && res.data.length > 0) {
      const sortedNew = [...res.data].sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());
      const latestMsg = sortedNew[sortedNew.length - 1];
      const companyIdForSort = typeof props?.data?.job_id?.company_id === 'string' ? props?.data?.job_id?.company_id : (props?.data?.job_id?.company_id?._id);
      if (props.updateLastMessageTime) props.updateLastMessageTime(companyIdForSort, job_id, latestMsg.createdAt);
    }
    
    setTotalPage(Math.ceil(res?.pagination?.total/limit))
    if(showLoader) setLoader(false)
    }
    else {
    if(showLoader) setLoader(false)
    }
    }
    catch(e) {
    if(showLoader) setLoader(false)
    }
       }
useEffect(()=> {
  const expectedCompanyId = typeof props?.data?.job_id?.company_id === 'string' ? props?.data?.job_id?.company_id : (props?.data?.job_id?.company_id?._id || props?.data?.company_id);

  if(props?.data?.job_id?._id && cleanerId && expectedCompanyId) {
    fetchChat(props?.data?.job_id?._id, cleanerId, expectedCompanyId)
  }
},[props?.data?.job_id?._id, page, cleanerId, props?.data?.company_id, props?.data?.job_id?.company_id])
 const handleImageClick = ()=> {
        setImageId('')
        setImageUrl('')
      }
      const handleImage = async (e)=> {
        setLoader(true)
      const formData = new FormData()
      formData.append('cleaner_id', cleanerId);
      formData.append('chat_img', e.target.files[0]);
      const result = await uploadFile(formData);
          if(result?.success===true) {
            setImageId(result?.data?.files[0].key)
            setImageUrl(URL.createObjectURL(e.target.files[0]))
            setLoader(false)
          }
          else {
            setLoader(false)
          }
      
      
      }
const handleScroll = () => {
 if (messagesEndRef.current?.scrollTop === 0 && totalPage>page) {
  setPage((prev) => prev + 1);
}

};
useEffect(() => {
  if (page === 1) {
    setTimeout(() => scrollToBottom(messagesEndRef), 100);
  } else if (messagesEndRef.current && previousScrollHeightRef.current > 0) {
      const newScrollHeight = messagesEndRef.current.scrollHeight;
      const heightDifference = newScrollHeight - previousScrollHeightRef.current;
      messagesEndRef.current.scrollTop = previousScrollTopRef.current + heightDifference;
      previousScrollHeightRef.current = 0;
  }
}, [allmessage, page]);


  return (
    <>
      {loader && <LoaderFullScreen></LoaderFullScreen>}
    <div>
    <div className='flex justify-between items-center py-3 px-3'>
        <div>
        <h1 className='text-2xl  text-[#595959]'>{props?.data?.job_id?.company_id?.company_name}</h1>
        <p className=''>Applied to {props?.data?.job_id?.job_title} in {props?.data?.job_id?.job_advanced_id?.reporting_address?.city}</p>
        </div>
    </div>
<hr className="border-2 border-neutral-200" />
<div className="flex flex-col h-[60vh] justify-between">
<div onScroll={handleScroll}
 ref={messagesEndRef} className='flex-1 h-[60vh] overflow-auto mb-3'>
<div className='text-center mb-10 mt-3'>
Applied {DateFormat(props?.data?.createdAt)}
</div>
<div>
 {allmessage?.sort((a, b)=> {
  const adate = new Date(a?.createdAt)
  const bdate = new Date(b?.createdAt)

  const differenceInMilliseconds = adate.getTime() - bdate.getTime();
  return differenceInMilliseconds
 }).map((item, index, array)=> {
    const currentDate = new Date(item?.createdAt).toDateString();
    const prevDate = index > 0 ? new Date(array[index - 1]?.createdAt).toDateString() : null;
    const showDateDivider = currentDate !== prevDate;

    return (
   <React.Fragment key={item?._id}>
    {showDateDivider && (
        <div className="flex items-center justify-center mb-4 mt-6">
          <div className="border-t flex-1 mr-4"></div>
          <span className="text-gray-400 text-xs font-bold">
            {currentDate === new Date().toDateString() ? "Today" : DateFormat(item?.createdAt)}
          </span>
          <div className="border-t flex-1 ml-4"></div>
        </div>
    )}
    <div>
    {(item?.sender_id?.id || item?.sender_id)  === cleanerId ?(
      <div className='flex justify-end items-center space-x-2 px-2'>
<svg xmlns="http://www.w3.org/2000/svg" focusable="false" role="img" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" className="w-6 h-6 text-[#0d2d5e]"><path d="M12 12c2.486 0 4.5-2.014 4.5-4.5S14.486 3 12 3a4.499 4.499 0 00-4.5 4.5C7.5 9.986 9.514 12 12 12zm0 2.25c-3.004 0-9 1.508-9 4.5v1.75a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-1.75c0-2.992-5.996-4.5-9-4.5z"></path></svg>
    <div>
    <div className='flex-1 flex justify-start items-center space-x-2'>
    <div className=' text-base'> You </div>
    <div className='text-sm'>
     {getTimeFromDate(item?.createdAt)}
    </div>
    </div>
    <div className='text-[#595959]'>
  {item?.message}
    </div>
    {item?.file_id &&
                    <ChatImg item={item}></ChatImg>
               }
    </div>
</div>
    ):(
      <div className='flex justify-start items-center space-x-2 px-2 pb-6'>
    <div className='bg-[#0d2d5e] rounded-full text-white max-h-7 max-w-[1.75rem] px-4 py-4 flex items-center justify-center'>
    {props?.data?.job_id?.company_id?.company_name?.slice(0,1)?.toUpperCase()} 
    </div>
    <div>
    <div className='flex-1 flex justify-start items-center space-x-2'>
    <div className='text-sm'>
   {getTimeFromDate(item?.createdAt)}
    </div>
    </div>
    <div className='text-[#595959]'>
    <DisplayMessageReceiver item={item} fetchUnreadCount={props?.fetchUnreadCount} fetchUnreadApplication={props?.fetchUnreadApplication} clearUnreadForJob={props?.clearUnreadForJob}></DisplayMessageReceiver>
    </div>
    {item?.file_id &&
                    <ChatImg item={item}></ChatImg>
               }
    <div />
    </div>
</div>
)}
</div>
</React.Fragment>)})}
  
  </div>
</div>
<ChatBottom imageUrl={imageUrl} uploadChange={handleImage} handleImageClick={handleImageClick} Send={sendMessage} Clear={()=> setMessage('')} onChange={(e)=> setMessage(e.target.value)} value={message} />

</div></div>
</>
  )
}
